import React from 'react';
import { HtmlParse } from 'utils';
import Price from "components/Price";
import {minPurchasePrime} from 'config';
import logoPrime from 'images/icons/logo-jumbo-prime.svg';
import style from './style.scss';

const CencoPrime = (props) => {

    let textPrime = '';

    if(props.primeCat){
        textPrime = ' con <strong>T. Cencosud Scotiabank</strong>.';
    }
    else{
        textPrime = ' en productos.'; 
    }

    return (
        <div className="cart-control-cenco-prime">
            <i className="cart-control-cenco-prime-logo">{HtmlParse(logoPrime)}</i>
            <span className="cart-control-cenco-prime-text">Recuerda que tienes despacho gratis en tus compras sobre <Price price={minPurchasePrime}/>{HtmlParse(textPrime)}</span>
        </div>
    )
}

export default CencoPrime;